import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";

import leftArrow from "../../../assets/images/left-arrow.svg";
import walletIcon from "../../../assets/images/wallet-icon.svg";
import webIcon from "../../../assets/images/web-icon.svg";
import cartIcon from "../../../assets/images/cart-icon-online.svg";
import eyeIcon from "../../../assets/images/eye-icon.svg";
import shareIcon from "../../../assets/images/share.svg";
import backIconWhite from "../../../assets/images/right-arrow-white.svg";
import shareStoreMedia1 from "../../../assets/images/media-1.svg";
import shareStoreMedia2 from "../../../assets/images/media-2.svg";
import shareStoreMedia3 from "../../../assets/images/media-3.svg";
import shareStoreMedia4 from "../../../assets/images/media-4.svg";
import shareStoreMedia5 from "../../../assets/images/media-5.svg";
import { EmailShareButton, FacebookShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
import { useSelector } from "react-redux";
import { useToast } from "../../../toast";
import { useHistory } from "react-router-dom";
import { getStoreDetails, onUpdateDomain } from "../../../services";
function StoreOnline() {
  const profileDetails = useSelector((state) => state.profileDetails)
  const toast = useToast()
  const history = useHistory()
  const [offline, setoffline] = useState(false)
  const [offTempline, setoffTempline] = useState(false)
  const [storeDetails, setStoreDetails] = useState({})
  const allowNavigationRef = useRef(false);
  useEffect(() => {
    getStoreDetail()
  }, [])
  const getStoreDetail = () => {
    getStoreDetails().then((res => {
      if (res.status) {
        setStoreDetails(res.data)
        setoffline(!res.data.status)
      }
    }))
  }

  const onCopyLink = () => {
    if (storeDetails?.status) {
      navigator.clipboard.writeText(`${window.location.origin}/${profileDetails?.cp_creator_domains[0]?.domain_name}`);
      toast.buttomOpen("Link copied successfully");
    } else {
      toast.buttomOpen("Please make your store online in order to share the link")
    }
  }

  const handleToggle = (e) => {
    setoffline(!offTempline)
    onUpdateDomain({ "status": offTempline ? "1" : "0" }).then(() => {
      toast.buttomOpen("Your website is now deactivated.")
      getStoreDetail()
    })
  }
  const deActivatePopUp = (e) => {
    if (offline) {
      onUpdateDomain({ "status": !e.target.checked ? "1" : "0" }).then(() => {
        toast.buttomOpen("Your website is now activated. Share the URL with your friends and start earning money.")
        getStoreDetail()
      })
      return
    }
    $("#deactivate-store").modal("show")
    setoffTempline(!e.target.checked)
  }


  const onAddProduct = () => {
    localStorage.setItem('product_count', '0');
      window.location.href = 'https://stage-creatorpro.myjosh.in/affiliate_store/index?d_type=web&src=add-product';
  };

  return (
    <>
      <div className="mobile-responsive-bar bar-block">
        <div className="mobile-header-wrap d-block d-md-none d-flex mob-header">
          <img className="leftArrow" src={leftArrow} onClick={() => history.goBack()} alt="" />
          <p className="editstoreText mb-0">Store</p>
          <div className="header-icon"> </div>
        </div>
      </div>
      <div className="store-online-wrap">
        <ul>
          <li className="deactivate-li">
            <div className="online-btn">
              <div class="toggle-btn">
                <label class="switch">
                  <input type="checkbox" checked={offline} onChange={(e) => deActivatePopUp(e)} />
                  <span class="slider round"></span>
                </label>
              </div>
            </div>
            <img className="web-img" src={webIcon} alt="" /> <h2> Deactivate Website</h2>
            <p className="mw-90"> Deactivating your website will make your store offline. Your friends won't be able to access your store</p>
          </li>
          <li onClick={() => onAddProduct()}>
            <img className="web-img" src={cartIcon} alt="" /> <h2> Add Products</h2>
            <img className="navigate-btn" src={backIconWhite} alt="" />
          </li>
          <li onClick={() => history.push('/store-preview')}>
            <img className="web-img" src={eyeIcon} alt="" /> <h2> Store Preview</h2>
            <img className="navigate-btn" src={backIconWhite} alt="" />
          </li>
          <li>
            <img className="web-img" src={shareIcon} alt="" /> <h2> Share  Your Store </h2>
            {/* <img className="navigate-btn" src={backIconWhite} alt="" /> */}
          </li>
          <div className="share-link-wrap">
            <div className={`form-gorup`}>
              <input
                className="form-control"
                placeholder="Share Url"
                type="text"
                value={`${window.location.origin}/${profileDetails?.cp_creator_domains?.[0]?.domain_name}`}
              />
              <div className="common-btn">
                <button className={`${!storeDetails?.status && "btn-disable"}`} onClick={onCopyLink}>Copy Link</button>
              </div>
            </div>
            {storeDetails?.status && <div className="share-others">
              <p> or share via</p>
              <ul>
                <li>
                  {" "}
                  <a>
                    <FacebookShareButton id="whatsapp-share" className='whatsapp-share' url={`${window.location.origin}/${profileDetails?.cp_creator_domains?.[0]?.domain_name}`}>
                      <img src={shareStoreMedia1} alt="" />
                    </FacebookShareButton>
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="javascript:void(0);">
                    <img src={shareStoreMedia2} alt="" />
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="javascript:void(0);">
                    <WhatsappShareButton id="whatsapp-share" className='whatsapp-share' url={`${window.location.origin}/${profileDetails?.cp_creator_domains?.[0]?.domain_name}`}>
                      <img src={shareStoreMedia3} alt="" />
                    </WhatsappShareButton>
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="javascript:void(0);">
                    <TwitterShareButton id="whatsapp-share" className='whatsapp-share' url={`${window.location.origin}/${profileDetails?.cp_creator_domains?.[0]?.domain_name}`}>
                      <img src={shareStoreMedia4} alt="" />
                    </TwitterShareButton>
                  </a>
                </li>
                <li>
                  {" "}
                  <a href="javascript:void(0);">
                    <EmailShareButton id="whatsapp-share" className='whatsapp-share' url={`${window.location.origin}/${profileDetails?.cp_creator_domains?.[0]?.domain_name}`}>
                      <img src={shareStoreMedia5} alt="" />
                    </EmailShareButton>
                  </a>
                </li>
              </ul>
            </div>}
          </div>
        </ul>
      </div>
      {/* Deactivate pop up start here */}
      <div
        className="modal fade logout-popup-wrap save-store-popup"
        id="deactivate-store"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        data-backdrop="static"
        data-keyboard="false"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered custom-popup "
          role="document"
        >
          <div className="modal-content">
            <div className="modal-body ">
              <div className="logout-card">
                <h2>Deactivate website</h2>
                <p>Your website URL will be deactivated. Do you want to make our store offline?</p>
              </div>
            </div>
            <div className="modal-footer">
              <div className="common-btn">
                <button data-dismiss="modal" onClick={() => handleToggle()}>Yes</button>
                <button data-dismiss="modal" onClick={() => setoffTempline(!storeDetails?.status)}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Deactivate pop up ends here */}
    </>
  );
}

export default StoreOnline;
